export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '419846dc-8611-4485-b0a0-3e7dc7da9740';
export const MODAL_CLOSE_SEC = 2.5;